/**
 * The module for managing the applications modals
 */
export default {
    namespaced: true,

    state: {
        modal: null,
        modalData: null,
        resultData: null,
        updateData: null,
        lastUpdated: 0,
        keepAlive: false
    },

    getters: {
        current: state => state.modal,
        dataForModal: state => state.modalData,
        resultFromModal: state => state.resultData,
        updateFromModal: state => state.updateData,
        lastUpdated: state => state.lastUpdated,
        canDiscard: state => state.keepAlive,
    },

    actions: {
        open ({commit}, data) {
            commit('open', data);
        },
        close ({commit}, result) {
            commit('close', result);
        },
        update ({commit}, data) {
            commit('update', data);
        },
        keepAlive ({commit}, value) {
            commit('keepAlive', value);
        },
    },

    mutations: {
        open (state, data) {
            state.modal = data.name;
            state.modalData = data.data || null;
            state.resultData = null;
            state.updateData = null;
            state.lastUpdated = 0;
            state.keepAlive = false;
        },
        close (state, result) {
            const data = {
                name: state.modal,
                data: result,
            };
            state.modal = null;
            state.modalData = null;
            state.resultData = result ? data : null;
            state.updateData = null;
            state.lastUpdated = 0;
            state.keepAlive = false;
        },
        update (state, data) {
            state.updateData = {name: state.modal, data};
            state.lastUpdated = Date.now();
        },
        keepAlive (state, value) {
            state.keepAlive = value;
        }
    },
};
